import {panelOptions} from "../../panel/consts.jsx";

export const accuracyResultsTitles = {
    [panelOptions.happyHours]: "סינון תוצאות לפי מה חשוב לכם"
};

export const foodRelatedReferencesTitles = {
    [panelOptions.happyHours]: "התייחסויות שקשורות לאוכל"
};

export const foodRelatedReferencesSubtitles = {
    [panelOptions.happyHours]: "הצג חבילות המציעות מענה ושילוב מנות עבור"
};
